import { Platform } from 'react-native'
import Constants from 'expo-constants'

const auth0Config = Constants.expoConfig?.extra?.auth0 as
  | {
      domain?: string
      client?: { ios?: string; android?: string; web?: string }
      audience?: string
      redirectUri?: string
    }
  | undefined

export const AUTH0_DOMAIN = auth0Config?.domain ?? ''
export const AUTH0_CLIENT_ID =
  auth0Config?.client?.[Platform.OS as keyof typeof auth0Config.client] ?? ''
export const AUTH0_AUDIENCE = auth0Config?.audience
export const AUTH0_REDIRECT_URI = auth0Config?.redirectUri
